// extracted by mini-css-extract-plugin
export default {"serviceCardWrapper":"BlogSectionS2_serviceCardWrapper__QzmOS","swingUpDown":"BlogSectionS2_swingUpDown__ogqQQ"};